import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DateService } from 'src/app/services/date.service';
import { VmsService } from 'src/app/services/vms.service';

@Component({
  standalone: false,
  selector: 'app-invite-detail',
  templateUrl: './invite-detail.component.html',
  styleUrls: ['./invite-detail.component.scss'],
})
export class InviteDetailComponent implements OnInit, OnDestroy {
  id: any;
  fullName: string;
  mobileNumber: any;
  emailId: any;
  date: any;
  time: any;
  buildingName: string;
  floor: number;
  guestList: any;
  tempDate: any;
  approved: boolean = true;
  fromHistory: boolean;
  type: any;
  individualInvite: boolean;
  data: any;
  private subscriptions = new Subscription();
  tempData: any;
  individualInviteRoute: string;
  vehicleData: any;

  constructor(
    private vmsSrv: VmsService,
    private activatedRoute: ActivatedRoute,
    private dateSrv: DateService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getVehicleType();
    if (localStorage.getItem('navigate') == '2') this.fromHistory = true;
    if (localStorage.getItem('navigate') == '1') this.fromHistory = false;
    this.activatedRoute.queryParams.subscribe((res) => {
      this.id = res.id ? res.id : null;
      this.individualInvite = res?.type == 'individual' ? true : false;
      this.individualInviteRoute =
        res?.type == 'individual' ? 'individual-invite' : 'bulk-invite';
      this.loadData(this.id);
    });
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  getVehicleType() {
    this.subscriptions.add(
      this.vmsSrv.getVehicleType().subscribe((res) => {
        console.log(res);
        this.vehicleData = res;
      })
    );
  }

  getVehicalName(id) {
    if (id == null)  return '--NA--';
    else  return this.vehicleData.filter((res) => res.vehicleTypeId == id)[0]?.vehicleType;
  }

  loadData(id) {
    const data = {
      InvitationID: id,
    };
    this.subscriptions.add(
      this.vmsSrv.getInvitationDetail(data).subscribe((res) => {
        console.log(res);
        this.data = res;
        this.tempData = this.data;
        this.approved = res.isApproved;
      })
    );
  }

  formatDate(date, type) {
    if (date == null) return;
    if (type == 'date') {
      this.tempDate = date.split('T')[0].split('-');
      return this.dateSrv.convertDateToLocaleString(
        this.tempDate[2],
        this.tempDate[1],
        this.tempDate[0]
      );
    }
    if (type == 'time') {
      this.tempDate = date.split('T')[1].split(':');
      return this.tempDate[0] + ':' + this.tempDate[1];
    }
  }

  generateUniqueId(i, type) {
    return i + '__' + type;
  }

  deleteSelected(inviteData, i) {
    const data = {
      guestId: inviteData,
      invitationId: this.id,
    };
    this.subscriptions.add(
      this.vmsSrv.deleteGuest(data).subscribe((res) => {
        if (res.isValid) {
          this.loadData(this.id);
        }
      })
    );
  }

  cancelInvite(id) {
    this.subscriptions.add(
      this.vmsSrv.cancelInvitation(id).subscribe((res) => {
        console.log(res);
      })
    );
  }

  resendInvite(id) {
    this.subscriptions.add(
      this.vmsSrv.resendInvitation(id).subscribe((res) => {
        console.log(res);
        if (res?.isValid)
          this.router.navigate(['/vms/individual-invite/status'], {
            queryParams: { id: id },
          });
      })
    );
  }

  reInvite(item,type){
    console.log(type)
    if(type)
    this.router.navigate(['/vms/individual-invite/invite'],{queryParams:{id:item}});

    if(!type)
      this.router.navigate(['/vms/bulk-invite/preview'],{queryParams:{id:item}});


  }
}
